const testimonials = [
  {
    id: 1,
    name: 'Regina Miles',
    title: 'CEO',
    org: 'AZ Technology Inc.',
    desc:
      'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown printer took a galley of type.',
  },
  {
    id: 2,
    name: 'Anne',
    title: 'Co-founder',
    org: 'Micron Technology Inc.',
    desc:
      'It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.',
  },
  {
    id: 3,
    name: 'Suzanne',
    title: 'Marketing Head',
    org: 'Seaco Technologies',
    desc:
      'It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has distribution of letters.',
  },
];
export default testimonials;
